import React from 'react'
import Navbar from '../components/Navbar'
import Footer from '../components/Footer'

const Certificate = () => {
  return (
    <>
      <Navbar></Navbar>
      <section className="mrg_tb">
        <div className="container">
          <div className="heading d-flex flex-column justify-content-center align-items-center mb-4">
            <h2 className="Viga text-center  wow animate__flash" data-wow-duration="1s">Certification
              <span className="cl-theme"></span></h2>
          </div>
          <div className="row d-flex justify-content-center align-items-center my-5">
            <div className="col-lg-6 my-3 my-lg-0 d-flex justify-content-center justify-content-lg-start wow animate__fadeInUp" data-wow-delay="0s" data-wow-duration="1s">
              <img src="/images/iec.png" alt="Image of About Us Page" draggable="false" className="img-fluid px-3" />
            </div>
            <div className="col-lg-6 my-3 my-lg-0 wow animate__fadeInLeft" data-wow-delay="0.5s" data-wow-duration="1s">
              <h2 className="Viga">IEC Code<span className="cl-theme"></span></h2>
              <div className="cusLineH mt-1">
                <p className='mb-4'>The Importer Exporter Code (IEC)</p>
                <a href="/pdfs/IEC.pdf" download className="cusBtn">Download Certificate</a>
              </div>
            </div>

          </div>
          <div className="row d-flex justify-content-center align-items-center my-5">
            <div className="col-lg-6 my-3 my-lg-0 wow animate__fadeInLeft" data-wow-delay="0.5s" data-wow-duration="1s">
              <h2 className="Viga">GSTIN<span className="cl-theme"></span></h2>
              <div className="cusLineH mt-1">
                <p className='mb-4'>The Goods and Services Tax Identification Number (GSTIN)</p>
                <a href="/pdfs/GSTIN.pdf" download className="cusBtn">Download Certificate</a>
              </div>
            </div>
            <div className="col-lg-6 my-3 my-lg-0 d-flex justify-content-center justify-content-lg-start wow animate__fadeInUp" data-wow-delay="0s" data-wow-duration="1s">
              <img src="/images/gstin.png" alt="Image of About Us Page" draggable="false" className="img-fluid px-3" />
            </div>
          </div>
          <div className="row d-flex justify-content-center align-items-center my-5">
            <div className="col-lg-6 my-3 my-lg-0 d-flex justify-content-center justify-content-lg-start wow animate__fadeInUp" data-wow-delay="0s" data-wow-duration="1s">
              <img src="/images/msme.png" alt="Image of About Us Page" draggable="false" className="img-fluid px-3" />
            </div>
            <div className="col-lg-6 my-3 my-lg-0 wow animate__fadeInLeft" data-wow-delay="0.5s" data-wow-duration="1s">
              <h2 className="Viga">MSME<span className="cl-theme"></span></h2>
              <div className="cusLineH mt-1">
                <p className='mb-4'>The Micro, Small and Medium Enterprises (MSME)</p>
                <a href="/pdfs/MSME.pdf" download className="cusBtn">Download Certificate</a>
              </div>
            </div>
          </div>
          <div className="row d-flex justify-content-center align-items-center my-5">
          <div className="col-lg-6 my-3 my-lg-0 wow animate__fadeInLeft" data-wow-delay="0.5s" data-wow-duration="1s">
              <h2 className="Viga">APEDA<span className="cl-theme"></span></h2>
              <div className="cusLineH mt-1">
                <p className='mb-4'>The Agricultural and Processed Food Products Export Development Authority (APEDA)</p>
                <a href="/pdfs/APEDA.pdf" download className="cusBtn">Download Certificate</a>
              </div>
            </div>
            <div className="col-lg-6 my-3 my-lg-0 d-flex justify-content-center justify-content-lg-start wow animate__fadeInUp" data-wow-delay="0s" data-wow-duration="1s">
              <img src="/images/apeda.png" alt="Image of About Us Page" draggable="false" className="img-fluid px-3" />
            </div>
          </div>
        </div>
      </section>
      <Footer></Footer>
    </>
  )
}

export default Certificate